import React, { useState, useCallback } from "react";
import { EventButton, CountdownTimer } from "../common";

const QuizScreen = ({
  question,
  onSubmit,
  loading = false,
  cooldownUntil,
  disabled = false,
}) => {
  const [answer, setAnswer] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const isCooldown = cooldownUntil && new Date(cooldownUntil) > new Date();

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (!answer.trim() || loading || disabled || isCooldown) return;

      setSubmitted(true);
      onSubmit(answer.trim());
    },
    [answer, loading, disabled, isCooldown, onSubmit]
  );

  const handleInputChange = useCallback((e) => {
    setAnswer(e.target.value);
    setSubmitted(false);
  }, []);

  const handleCooldownExpire = useCallback(() => {
    setSubmitted(false);
  }, []);

  if (!question) return null;

  return (
    <div className="newyear-quiz">
      <div className="newyear-quiz__header">
        <span className="newyear-quiz__number">문제 {question.order}</span>
        <span className={`newyear-quiz__difficulty newyear-quiz__difficulty--${question.difficulty?.toLowerCase()}`}>
          {question.difficulty}
        </span>
      </div>

      <div className="newyear-quiz__content">
        <p className="newyear-quiz__text">{question.questionText}</p>

        {question.hint && (
          <p className="newyear-quiz__hint">힌트: {question.hint}</p>
        )}
      </div>

      <form className="newyear-quiz__form" onSubmit={handleSubmit}>
        <div className="newyear-quiz__input-wrapper">
          <input
            type="text"
            className="newyear-quiz__input"
            value={answer}
            onChange={handleInputChange}
            placeholder="정답을 입력하세요"
            disabled={loading || disabled || isCooldown}
            maxLength={100}
          />
        </div>

        {isCooldown && (
          <div className="newyear-quiz__cooldown">
            <CountdownTimer
              deadline={cooldownUntil}
              label="재응모 가능까지"
              onExpire={handleCooldownExpire}
            />
          </div>
        )}

        <EventButton
          type="submit"
          disabled={!answer.trim() || disabled || isCooldown}
          loading={loading}
          fullWidth
          variant="primary"
        >
          {isCooldown ? "대기 중" : "정답 제출"}
        </EventButton>
      </form>
    </div>
  );
};

export default QuizScreen;
